<template>
 <!-- v-show="showpop"   :style="showpop?'visibility:hidden;':"-->
<div class="maskTips" v-show="showpop">
    <div v-if="iscopy" style="width: 100%;height: 100%;background: rgba(0, 0, 0, 0.4);">
        <!-- <svg-icon icon-class="close1" class-name="close1-svg close" @click="closePop"/> -->
        <iframe src="./pricing.html" id="mainIframe" ref="mainIframe" name="mainIframe" style="width:100%;height:100%;overflow-x: hidden;border: 0px;margin-top: -20px;"></iframe>
    </div>
    <div v-else style="padding: 0px 0px 40px 0;max-width: 1400px;border-radius: 16px;">
        <div class="maskRights">
            <div class="buySuccess">
                <i class="close"></i>
                <div>
                <img src="../assets/success.svg" alt="Success" />
                <p class="info Member">{{$t("return_home")}}</p>
                <p class="info noMember">{{$t("congratulations")}}<span class="loginMaskbtn">{{$t("login_benefits")}}</span>{{$t("no_registered")}}<span class="registerMaskbtn">{{$t("register_account")}}</span>{{$t("other_accounts")}}</p>
                <span class="btn">{{$t("btn_close")}}</span>
                </div>
            </div>
        </div>
        <i class="close" @click="closePop"></i>
        <!-- <svg-icon class="close1" class-name="close-svg close" @click="closePop"></svg-icon> -->
        
        <div class="buy">
            <div class="container">
                <h1>{{$t("pricing.h1")}}</h1>
                <p>{{$t('pricing.banner_content')}}</p>
                <div class="buy_box flex_box">
                <div class="best">
                    <span>{{$t('pricing.best_seller')}}</span>
                    <p class="title"><i></i>{{$t('pricing.monthly')}}</p>
                    <p class="price">{{pricing.symbol}}{{showMonthPrice}}</p>
                    <div class="credits">
                        <div 
                        :class="{ active: activeMonthly == index }"
                        :plan="index"
                        v-for="(item,index) in monthInfo" :key="index"
                        @click="selectMonthly(index)">
                            <i></i>
                            <span>{{item.credits}} {{$t('pricing.credits')}} <span class="off" v-if="item.off">{{item.off}} OFF</span></span>
                            <span class="price">{{pricing.symbol}}{{item.discount_price}}</span>
                            <del>{{pricing.symbol}}{{item.original_price}}</del>
                        </div>
                    </div>
                    <span class="btn account_buy" plan="46" data-account-productid="179"><span><i></i>{{$t("pricing.buy_now")}}</span></span>
                </div>
                <div class="lifetime">
                    <p class="title">{{$t('pricing.lifetime')}}</p>
                    <p class="price">{{pricing.symbol}}{{showLifetimePrice}}</p>
                        <div class="credits">
                            <div :class="{ active: activeLifetime == index }"
                                :plan="index"
                                v-for="(item,index) in lifetimeInfo" :key="index"
                                @click="selectLifetime(index)">
                                <i></i>
                                <span>{{item.credits}} {{$t('pricing.credits')}}</span>
                                <span class="price">{{pricing.symbol}}{{item.discount_price}}</span>
                                <del>{{pricing.symbol}}{{item.original_price}}</del>
                            </div>
                        </div>
                    <span class="btn account_buy" plan="50" data-account-productid="179"><span><i></i>{{$t("pricing.buy_now")}}</span></span>
                </div>
                </div>
            </div>
        </div>
        <p class="note_tips"><span>{{$t('pricing.note')}}</span>: {{$t('pricing.note_content')}}</p>
    </div>
</div>
</template>
<script>
import utils from '@/js/utils.js';

export default {
    props:{
        showmodule:{
            type:Boolean,
            default:false,
        },
    },
    data(){
        return {
            iscopy:isCopy,
            showpop:false,
            issilder:false,
            activeMonthly: 46,   // 包月默认选中 plan=46
            activeLifetime: 50,  // 终身默认选中 plan=50
            pricing:{
                "paddle_vendor":106347,
                "symbol":'$',
                "place":false,
                // 包月 plan ID
                'month':{   
                    '46': {
                        "original_price": "23.60",
                        "discount_price": "14.90",
                        "credits": 200
                    },
                    "47": {
                        "original_price": "59.00",
                        "discount_price": "24.90",
                        "credits": 500
                    },
                    "48": {
                        "original_price": "118.00",
                        "discount_price": "39.90",
                        "credits": 1000
                    },
                    "49": {
                        "original_price": "236.00",
                        "discount_price": "59.90",
                        "credits": 2000
                    }
                },
                "lifetime":{
                    // 终身 plan ID
                    "50": {
                        "original_price": "39.90",
                        "discount_price": "29.90",
                        "credits": 200
                    },
                    "51": {
                        "original_price": "74.75",
                        "discount_price": "49.90",
                        "credits": 500
                    },
                    "52": {
                        "original_price": "149.50",
                        "discount_price": "69.90",
                        "credits": 1000
                    },
                    "53": {
                        "original_price": "299.00",
                        "discount_price": "99.90",
                        "credits": 2000
                    }
                }
            },
        }
    },
    computed:{
        monthInfo(){
            return this.pricing.month;
        },
        lifetimeInfo(){
            return this.pricing.lifetime;
        },
        showMonthPrice(){
            return this.pricing.month[this.activeMonthly].discount_price;
        },
        showLifetimePrice(){
            return this.pricing.lifetime[this.activeLifetime].discount_price;
        }
    },
    components:{
    },
    mounted(){
        //  $('.maskRights').show();
        // $('.buySuccess').show().siblings().hide();
        var user=utils.getCookie('user');
        if(user){
            this.user=JSON.parse(user)
        }    
        var lang=utils.getLang();
        if(pricing[lang]){
            this.pricing=pricing[lang];
        }
        console.log(this.pricing,213)

    },
    created() {
      // 初始化时为window绑定一个方法
        window['vueDefinedMyProp'] = () => {
            console.log("关闭");
            this.closePop();
            // this.getUserById(userId)
        }      
    },
    watch(){
          
    },
    methods:{
          selectMonthly(plan) {
            this.activeMonthly = plan;
            document.querySelector(".best .account_buy").setAttribute("plan", plan);
        },
        selectLifetime(plan) {
            this.activeLifetime = plan;
            document.querySelector(".lifetime .account_buy").setAttribute("plan", plan);
        },
        silder(){
            var self=this;
            jQuery.fn.extend({
                silder:function(callback){
                    var that=this;
                    function resizeSilder(){
                        var arr=[];
                        var num=0;
                        for(var i=0;i<that.children('.num').children('span').length;i++){
                            arr.push(that.children('.num').children('span').eq(i).position().left-that.children('.bg').width()/that.children('.num').children('span').length/2-2)
                        }
                        arr[0]=-6
                        that.children('.bg').unbind('click');
                        that.children('.bg').click(function(e){
                            if(e.offsetX>that.children('.btn').position().left){
                                var clickI=Math.round(e.offsetX/(that.find('.bg').width()/(that.children('.num').children('span').length-1)))
                                run(arr[clickI]+10);
                            }else{
                                run(e.offsetX);
                            }
                        });
                        that.children('.btn').unbind('mousedown');
                        that.children('.btn').mousedown(function(){
                            that.parent().mousemove(function(e){
                                run(e.offsetX);
                            });
                            $(document).mouseup(function(){
                                that.parent().off('mousemove')
                            })
                        });
                        that.children('.btn').unbind('mousemove');
                        that.children('.btn').mousemove(function(e){
                            e.stopPropagation();
                        });
                        that.children('.btn').unbind('touchstart')
                        that.children('.btn').on('touchstart',function(){
                            that.parent().on('touchmove',function(e){
                                run(e.originalEvent.changedTouches[0].clientX);
                            })
                            $(document).on("touchend",function(){
                                that.parent().off('touchmove');
                            });
                        });
                        that.children('.btn').unbind('touchstart');
                        that.children('.btn').on('touchstart',function(e){
                            e.stopPropagation();
                        });
                        
                        run(arr[1]+10)
                        function run(x){
                            for(var i=0;i<arr.length;i++){
                                if(x>arr[i]){
                                    that.children('.btn').css({'left':arr[i]+that.children('.bg').width()/that.children('.num').children('span').length/2+that.children('.num').children('span').eq(i).width()/2-12,'right':'unset'});
                                    that.children('.bg').children('i').css('width',arr[i]+that.children('.bg').width()/that.children('.num').children('span').length/2+10)
                                    if(i==0){
                                        that.children('.btn').css({'left':0,'right':'unset'})
                                        that.children('.bg').children('i').css('width','0')
                                    }
                                    if(i==arr.length-1){
                                        that.children('.btn').css({'left':'unset','right':0})
                                        that.children('.bg').children('i').css('width','100%')
                                    }
                                    num=i;
                                    callback(num)
                                }
                            }
                        }
                    }
                    resizeSilder()
                    var windowWidth=$(window).width();
                    $(window).resize(function(){
                        if(windowWidth!=$(window).width()){
                            resizeSilder()
                            windowWidth=$(window).width()
                        }
                    })
                }
            })
            
            $('.silder').silder(function(num){
                $('.buy_box .lifetime .info span').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .lifetime .price').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .lifetime .btn').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .monthly .info span').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .monthly .price').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .monthly .btn').eq(num).addClass('active').siblings().removeClass('active');
            });
            var buy_first=0;
            // 判断是否首次进入页面
            if(localStorage.getItem('buy_first')){
                buy_first=1
            }else{
                localStorage.setItem('buy_first',1)
            }
            var isbuy=0;
            var post_url;
            if(location.hostname=='www.aiseesoft.com' || 
            location.hostname=='www.aiseesoft.fr' || 
            location.hostname=='www.aiseesoft.de' || 
            location.hostname=='www.aiseesoft.jp' || 
            location.hostname=='zh-cn.aiseesoft.com' || 
            location.hostname=='zh-tw.aiseesoft.com' || 
            location.hostname=='cs.aiseesoft.com' || 
            location.hostname=='da.aiseesoft.com' || 
            location.hostname=='nl.aiseesoft.com' || 
            location.hostname=='fi.aiseesoft.com' || 
            location.hostname=='el.aiseesoft.com' || 
            location.hostname=='it.aiseesoft.com' || 
            location.hostname=='no.aiseesoft.com' || 
            location.hostname=='pl.aiseesoft.com' || 
            location.hostname=='pt.aiseesoft.com' || 
            location.hostname=='ru.aiseesoft.com' || 
            location.hostname=='www.aiseesoft.es' || 
            location.hostname=='sv.aiseesoft.com' || 
            location.hostname=='hu.aiseesoft.com' || 
            location.hostname=='tr.aiseesoft.com'
            ){
            // var paddle_vendor=106347;
            var paddle_vendor=self.pricing.paddle_vendor;
            post_url="https://account.api.aiseesoft.com/v13/";
            }else{
                post_url="https://sandbox.account.api.aiseesoft.com/v13/";
                Paddle.Environment.set('sandbox');
                var paddle_vendor=570;
            }
            Paddle.Setup({
                vendor: paddle_vendor,
                eventCallback: function(data) {
                    $('.buy_box .btn').removeClass('load');
                    if(data.event === 'Checkout.PaymentMethodSelected'){
                        if(!buy_first){
                            // _gaq.push(['_trackEvent',operation,'buy_payment_first','']);
                        }else{
                            // _gaq.push(['_trackEvent',operation,'buy_payment','']);
                        }
                    }
                    if (data.event === 'Checkout.PaymentComplete') {
                        isbuy=1;
                        // _gaq.push(['_trackEvent',operation,'buy_success','']);
                    }
                    if(data.event === 'Checkout.Close'&&isbuy){
                        $('.maskRights').show();
                        $('.buySuccess').show().siblings().hide();
                        if(getCookie('user')){
                            $('.buySuccess .Member').show().siblings('.info').hide();
                            // _gaq.push(['_trackEvent',operation,'buy_login','true']);utils
                        }else{
                            $('.buySuccess .noMember').show().siblings('.info').hide();
                            // _gaq.push(['_trackEvent',operation,'buy_login','false']);
                        }
                    }
                    if(data.event === 'Checkout.Error'){
                        // _gaq.push(['_trackEvent',operation,'buy_fail','']);
                    }
                }
            });

            // 0 正常  1 点击购买打开
            var loginBtnState=0;
            // 请求购买链接
            $('.buy_box .btn').click(function(){
                if($(this).attr('class').indexOf('load')>-1){
                    return false;
                }
                checkout($(this));
            });
            function checkout(that){
                // var data
                // var user=utils.getCookie('user');
                // if(user){
                //     user=JSON.parse(user)
                //     data={
                //         e_id:user.e_id,
                //         t_id:user.t_id,
                //         token:user.token,
                //         plan_id:that.attr('plan'),
                //     }
                // }else{
                //     try{
                //         data={
                //             e_id:murmur,
                //             plan_id:that.attr('plan'),
                //         }
                //     }catch(e){
                //         data={
                //             e_id:1,
                //             plan_id:that.attr('plan'),
                //         }
                //     }
                // }
                // data.language=utils.getLang();
                var language=utils.getLang();
                if(language=='jp'){
                    language="ja";
                }
                var data={
                    e_id:murmur,
                    gateway:gateway,
                    plan_id:that.attr('plan'),
                    language:language,
                }
                // _gaq.push(['_trackEvent',operation,'buy_planID',String(that.attr('plan'))]);
                that.addClass('load')
                // $.ajax({
                // url: utils.urlPost('image')+'sr',
                // type: 'post',
                // cache: false,
                // contentType: false,
                // processData: false,
                // data: formData,
                // success: function(res){
                //     console.log(res)
                //     if(res.status==200){
                //         self.getResult(res.key, scale, imageMd5, sign,id)
                //     }
                //     else{
                //         self.imgArr[id].state='changeResolutionError'
                //         // self.postImage(id+1)
                //     }
                // },
                // error: function(error){
                //     self.imgArr[id].state='changeResolutionError'
                //     // self.postImage(id+1)
                // }
                $.ajax({
                    url:post_url+"subscription/checkout",
                    type: 'post',
                    data:data,
                    success:function(data){
                        that.removeClass('load')
                        error_fn(data.error,that);
                        switch(data.error){
                            case 0:
                                var outerData=data;
                                // $.get(data.url+"?json=1",function(data){
                                    if(gateway==4){
                                        // 2checkout
                                        (function (document, src, libName, config,data) {
                                            var data=getUrlkey(data.url_gateway)
                                            var script             = document.createElement('script'); 
                                            script.src             = src; 
                                            script.async           = true; 
                                            script.id              ='buy2checkout'
                                            var firstScriptElement = document.getElementsByTagName('script')[0]; 
                                            script.onload          = function () {
                                                var isbuy=0;
                                                for (var namespace in config) {
                                                    if (config.hasOwnProperty(namespace)) {
                                                        window[libName].setup.setConfig(namespace, config[namespace]);
                                                    } 
                                                } 
                                                window[libName].register();
                                                TwoCoInlineCart.products.add({
                                                    code: data.prod,
                                                    quantity: data.qty,
                                                });
                                                try{
                                                    if(data.test){
                                                        TwoCoInlineCart.cart.setTest(true);
                                                    }
                                                }catch(e){
                                                    console.log(e)
                                                }
                                                if(data.lock){
                                                    TwoCoInlineCart.cart.setCartLockedFlag(true)
                                                }else{
                                                    TwoCoInlineCart.cart.setCartLockedFlag(false);
                                                }
                                                if(data['empty-cart']){
                                                    TwoCoInlineCart.cart.setReset(true)
                                                }else{
                                                    TwoCoInlineCart.cart.setReset(false)
                                                }
                                                TwoCoInlineCart.cart.setExpiration(data.expiration)
                                                TwoCoInlineCart.cart.setSignature(data.signature)
                                                // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                                TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                                TwoCoInlineCart.cart.checkout();
                                                TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                                })
                                                TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                                    if(isbuy){
                                                        $('.maskRights').show();
                                                        $('.buySuccess').show().siblings().hide();
                                                        if(getCookie('user')){
                                                            $('.buySuccess .Member').show().siblings('.info').hide();
                                                            // _gaq.push(['_trackEvent',operation,'buy_login','true']);
                                                        }else{
                                                            $('.buySuccess .noMember').show().siblings('.info').hide();
                                                            // _gaq.push(['_trackEvent',operation,'buy_login','false']);
                                                        }
                                                    }
                                                })
                                                TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                                    isbuy=1;
                                                    // _gaq.push(['_trackEvent',operation,'buy_success','']);
                                                })
                                            }; 
                                            firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                                        })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
                                    }else{
                                        data=JSON.parse(data)
                                        // paddle
                                        $.get(data.url+"?json=1",function(data){ 
                                            isbuy=0;
                                            Paddle.Checkout.open({
                                                override: JSON.parse(data).url
                                            });
                                        });
                                    }
                                // });
                                break
                            case 25301:
                                that.removeClass('load')
                                error(i18n[lang].error_25301);
                                break;
                            case 25302:
                                that.removeClass('load')
                                error(i18n[lang].error_25302);
                                break;
                            case 25303:
                                that.removeClass('load')
                                error(i18n[lang].error_25303);
                                break;
                            case 25304:
                                that.removeClass('load')
                                error(i18n[lang].error_25304);
                                break;
                            case 25305:
                                that.removeClass('load')
                                error(i18n[lang].error_25305);
                                break;
                            case 25306:
                                that.removeClass('load')
                                error(i18n[lang].error_25306);
                                break;
                        }
                    },
                    error: function(error){
                        overtime(25399);
                    }
                });
            }
            // function checkout(that){
            //     // var data
            //     // var user=utils.getCookie('user');
            //     // if(user){
            //     //     user=JSON.parse(user)
            //     //     data={
            //     //         e_id:user.e_id,
            //     //         t_id:user.t_id,
            //     //         token:user.token,
            //     //         plan_id:that.attr('plan'),
            //     //     }
            //     // }else{
            //     //     try{
            //     //         data={
            //     //             e_id:murmur,
            //     //             plan_id:that.attr('plan'),
            //     //         }
            //     //     }catch(e){
            //     //         data={
            //     //             e_id:1,
            //     //             plan_id:that.attr('plan'),
            //     //         }
            //     //     }
            //     // }
            //     // data.language=utils.getLang();
            //     var data={
            //         e_id:murmur,
            //         gateway:gateway,
            //         plan_id:that.attr('plan'),
            //     }
            //     // _gaq.push(['_trackEvent',operation,'buy_planID',String(that.attr('plan'))]);
            //     that.addClass('load')
            //     // $.ajax({
            //     // url: utils.urlPost('image')+'sr',
            //     // type: 'post',
            //     // cache: false,
            //     // contentType: false,
            //     // processData: false,
            //     // data: formData,
            //     // success: function(res){
            //     //     console.log(res)
            //     //     if(res.status==200){
            //     //         self.getResult(res.key, scale, imageMd5, sign,id)
            //     //     }
            //     //     else{
            //     //         self.imgArr[id].state='changeResolutionError'
            //     //         // self.postImage(id+1)
            //     //     }
            //     // },
            //     // error: function(error){
            //     //     self.imgArr[id].state='changeResolutionError'
            //     //     // self.postImage(id+1)
            //     // }
            //     $.ajax({
            //         url:post_url+"subscription/checkout",
            //         type: 'post',
            //         data:data,
            //         success:function(data){
            //             that.removeClass('load')
            //             error_fn(data.error,that);
            //             switch(data.error){
            //                 case 0:
            //                     var outerData=data;
            //                     $.get(data.url+"?json=1",function(data){
            //                         if(outerData.gateways[0]==4){
            //                             // 2checkout
            //                             (function (document, src, libName, config,data) {
            //                                 var data=getUrlkey(JSON.parse(data).url)

            //                                 var script             = document.createElement('script'); 
            //                                 script.src             = src; 
            //                                 script.async           = true; 
            //                                 script.id              ='buy2checkout'
            //                                 var firstScriptElement = document.getElementsByTagName('script')[0]; 
            //                                 script.onload          = function () {
            //                                     var isbuy=0;
            //                                     for (var namespace in config) {
            //                                         if (config.hasOwnProperty(namespace)) {
            //                                             window[libName].setup.setConfig(namespace, config[namespace]);
            //                                         } 
            //                                     } 
            //                                     window[libName].register();
            //                                     TwoCoInlineCart.products.add({
            //                                         code: data.prod,
            //                                         quantity: data.qty,
            //                                     });
            //                                     try{
            //                                         if(data.test){
            //                                             TwoCoInlineCart.cart.setTest(true);
            //                                         }
            //                                     }catch(e){
            //                                         console.log(e)
            //                                     }
            //                                     if(data.lock){
            //                                         TwoCoInlineCart.cart.setCartLockedFlag(true)
            //                                     }else{
            //                                         TwoCoInlineCart.cart.setCartLockedFlag(false);
            //                                     }
            //                                     if(data['empty-cart']){
            //                                         TwoCoInlineCart.cart.setReset(true)
            //                                     }else{
            //                                         TwoCoInlineCart.cart.setReset(false)
            //                                     }
            //                                     TwoCoInlineCart.cart.setExpiration(data.expiration)
            //                                     TwoCoInlineCart.cart.setSignature(data.signature)
            //                                     // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
            //                                     TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
            //                                     TwoCoInlineCart.cart.checkout();
            //                                     TwoCoInlineCart.events.subscribe('cart:opened', function () {
            //                                     })
            //                                     TwoCoInlineCart.events.subscribe('cart:closed', function () {
            //                                         if(isbuy){
            //                                             $('.maskRights').show();
            //                                             $('.buySuccess').show().siblings().hide();
            //                                             if(getCookie('user')){
            //                                                 $('.buySuccess .Member').show().siblings('.info').hide();
            //                                                 // _gaq.push(['_trackEvent',operation,'buy_login','true']);
            //                                             }else{
            //                                                 $('.buySuccess .noMember').show().siblings('.info').hide();
            //                                                 // _gaq.push(['_trackEvent',operation,'buy_login','false']);
            //                                             }
            //                                         }
            //                                     })
            //                                     TwoCoInlineCart.events.subscribe('payment:finalized', function () {
            //                                         isbuy=1;
            //                                         // _gaq.push(['_trackEvent',operation,'buy_success','']);
            //                                     })
            //                                 }; 
            //                                 firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
            //                             })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(JSON.parse(data).url).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
            //                         }else{
            //                             data=JSON.parse(data)
            //                             // paddle
            //                             $.get(data.url+"?json=1",function(data){ 
            //                                 isbuy=0;
            //                                 Paddle.Checkout.open({
            //                                     override: JSON.parse(data).url
            //                                 });
            //                             });
            //                         }
            //                     });
            //                     break
            //                 case 25301:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25301);
            //                     break;
            //                 case 25302:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25302);
            //                     break;
            //                 case 25303:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25303);
            //                     break;
            //                 case 25304:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25304);
            //                     break;
            //                 case 25305:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25305);
            //                     break;
            //                 case 25306:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25306);
            //                     break;
            //             }
            //         },
            //         error: function(error){
            //             overtime(25399);
            //         }
            //     });
            // }
            $('.buy_box .btn.unbind').unbind('click');
            $('.maskRights .close').click(function(){
                $('.maskRights').hide();
                $('.alert-mask').hide();
                self.showpop=false;
            });
            $('.buySuccess .btn').click(function(){
                $('.maskRights').hide();
                $('.alert-mask').hide();
                self.showpop=false;
            });
            // $('.maskMember').load("/mask-member.html",function(){
            //     $.getScript(accountHref+"js/unique.js",function(){
            //         $.getScript(accountHref+"js/i18n.js",function(){
            //             $.getScript(accountHref+"js/mask-member.js",function(){
            //                 console.log('mask-member')
            //             })
            //         })
            //     })
            //     var link = document.createElement("link");
            //     link.type = "text/css";
            //     link.rel = "stylesheet";
            //     link.href = accountHref+'css/mask-member.css';
            //     document.getElementsByTagName("head")[0].appendChild(link);
            // });
            // 打开注册弹窗
            // $('.registerMaskbtn').click(function(){
            //     $('.maskRights').hide();
            //     $('.maskMember').show();
            //     $('.member>.register').addClass('active').siblings('.box').removeClass('active');
            // });
            // 打开登录弹框
            // $('.loginMaskbtn').click(function(){
            //     $('.maskRights').hide();
            //     $('.maskMember').show();
            //     $('.member>.login').addClass('active').siblings('.box').removeClass('active');
            // });
            // $('#header .login_btn>a').click(function(){
            //     console.log(1);
            //     $('.maskMember').show();
            //     $('.member>.login').addClass('active').siblings('.box').removeClass('active');
            //     return false;
            // });
            // 关闭
            // $('.maskMember').on('click','.close',function(){
            //     $('.maskMember').hide();
            // });


            // 权益点击购买
            $('.buy_box_v1 .check input').change(function(){
                $(this).parent().parent().parent().addClass('active').siblings().removeClass('active');
                var plan=$(this).attr('id').split('-')[1];
                $(this).parent().parent().parent().parent().siblings('.btn').attr('plan',plan);
            });
            $('.buy_box_v1>div .btn').click(function(){
                checkout($(this));
            });
            $('.buy_box_v1>.rights .btn').unbind('click');

            (function(){
                try{
                    var _local = window.location.href.split('?plan=')[1],num=0;
                    if(_local.indexOf('&')>-1){
                        _local=_local.split('&')[0];
                    };
                    setTimeout(function(){
                        for(var j = 0;j<$('a.btn').length;j++){
                            if($('a.btn').eq(j).attr('plan')==_local){
                                $('a.btn').eq(j).trigger('click');
                            }
                        }
                    },1000);
                }catch(e){
                    console.log(e);
                }
            })();
            // url参数解析
            function getUrlkey(url) {
                var params = {};
                var urls = url.split("?");
                var arr = urls[1].split("&");
                for (var i = 0, l = arr.length; i < l; i++) {
                    var a = arr[i].split("=");
                    params[a[0]] = a[1];
                }
                return params;
            }

        },
        // 关闭弹窗
        closePop(){
            this.showpop=false;
            this.$emit('closePricingPop',this.showpop);
        },
    },
    watch:{
        showmodule(val){
            this.showpop=val;
            if(this.showpop && !this.issilder){
                this.issilder=true;
                setTimeout(() => {
                    this.silder();
                }, 1500);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.container {
    max-width: 1200px;
    // overflow: hidden;
    // padding: 0 5px;
    width: 100%;
    margin: auto;
    // box-sizing: border-box;
}
    .maskTips{
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.4);
        z-index: 9;
        // display: none;
        >div{
            background: #fff;
            box-shadow: 0px 6px 13px -4px rgba(0,0,0,0.5);
            
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            // max-width: 730px;
            // width: 100%;
            width: 98%;
            height: 80%;
            // padding: 30px 40px 50px;
            
            box-sizing: border-box;
            text-align: center;
            overflow-y: auto;
            
            >.close{
                float: right;
                width: 20px;
                height: 20px;
                background: url(../assets/close1.svg) no-repeat center center/cover;
                position: sticky;
                top: 16px;
                right: 16px;
                cursor: pointer;
                z-index: 2;
                &:hover{
                    background: url(../assets/close-h.svg) no-repeat center center/cover;
                }
            }
            >img{
                display: block;
                margin: auto;
            }
            >p{
                font-size: 16px;
                color: #333;
                line-height: 28px;
                margin-top: 26px;
                margin-bottom: 30px;
            }
            // .btn{
            //     display: inline-block;
            //     border-radius: 6px;
            //     min-width: 406px;
            //     cursor: pointer;
            // }
            .btn_v1{
                background: $btn_bg;
                color: #fff;
                line-height: 34px;
            }
            .btn_v1:hover{
                background: $btn_bg;
            }
            .btn_v2{
                line-height: 32px;
                border: 1px solid #979797;
                box-sizing: border-box;
                margin-top: 20px;
            }
            .errorList::-webkit-scrollbar{
                width: 4px;
            }
            .errorList::-webkit-scrollbar-thumb{
                background:rgba(0,0,0,.5);
                border-radius: 4px;
            }
            .errorList{
                max-height: 350px;
                overflow: auto;
                text-align: left;
                margin-bottom: 30px;
                border: 1px solid #F1F8FF;
                >div{
                    width: 100%;
                    height: 70px;
                    border-bottom: 1px solid #F1F8FF;
                    display: flex;
                    align-items: center;
                    >span{
                        width: 50%;
                        display: inline-block;
                        padding-left: 34px;
                        box-sizing: border-box;
                        vertical-align: middle;
                        color: #FE6363;
                        font-weight: normal;
                    }
                    .left{
                        padding-left: 34px;
                        display: flex;
                        align-items: center;
                        width: 50%;
                        box-sizing: border-box;
                        i{
                            width: 88px;
                            height: 52px;
                            position: relative;
                            background: #000;
                            background-size: contain;
                            background-position: center center;
                            background-repeat: no-repeat;
                        }
                        span{
                            font-weight: normal;
                            font-size: 16px;
                            color: #333;
                            margin-left: 6px;
                        }
                    }
                }
                >div:nth-child(1){
                    background: #F1F8FF;
                    span{
                        font-size: 16px;
                        font-weight: bold;
                        color: #333;
                    }
                }
                >div:last-child{
                    border-bottom: none;
                }
            }
        }
    }
.banner{background: #C3D9FF;background: linear-gradient(270deg, #C3D9FF 0%, #F3DAFF 55%, #FFEFE5 100%);padding-top: 55px;padding-bottom: 55px;}
.banner h1{text-align: center;font-size: 44px;font-weight: bold;line-height: 80px;color: #000;}

.tab_nav{text-align: center;margin-top: 36px;display: none;}
.tab_nav ul{display: inline-block;background: #F7F7F8;border-radius: 42px;padding: 8px;}
.tab_nav ul li{display: inline-block;font-size: 24px;color: #000;line-height: 66px;border-radius: 42px;font-weight: 600;padding-left: 26px;padding-right: 26px;min-width: 210px;box-sizing: border-box;cursor: pointer;position: relative;}
.tab_nav ul li.active{color: #fff;background: #E7766E;}
.tab_nav ul li.active i{color: #fff;}
.tab_nav ul li i{font-style: normal;font-size: 12px;color: #9A9B9C;position: absolute;left: 50%;bottom: 6px;-webkit-transform: translateX(-50%);transform: translateX(-50%);line-height: 12px;}

.silder_box{font-style: 18px;font-weight: bold;color: #000;line-height: 40px;margin-top: 40px!important;margin-bottom: 10px!important;}
.silder_box>div{border-radius: 6px;padding: 20px;}
.silder_box>div>p{font-size: 18px;line-height: 40px;color: #000;text-align: center;margin-bottom: 10px;}
.silder_box *{-webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;}
.silder{position: relative;opacity: 0;height: 0;overflow: hidden;}
.silder.active{display: block;opacity: 1;height: auto;overflow: visible;}
.silder .num span{font-size: 16px;color: #333;position: relative;}
.silder .num span::after{clear: both;content: "";width: 2px;height: 10px;background: #fff;position: absolute;left: 50%;bottom: -18px;z-index: 1;}
.silder .num span:first-child::after,.silder .num span:last-child::after{display: none;}
.silder .bg{background: #d4ddf5;border-radius: 5px;height: 10px;margin-top: 8px;position: relative;}
.silder .btn{width: 30px;height: 30px;border: 4px solid #FFFFFF;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.37);background: #627CFF;background: linear-gradient(236deg, #627CFF 0%, #C52DE4 47%, #F68C36 100%);border-radius: 50%;position: absolute;left: -6px;top: 37px;box-sizing: border-box;z-index: 2;cursor: pointer;}
.silder .bg i{background: #FD7B4D;background: linear-gradient(90deg, #FD7B4D 0%, #9560E1 100%);width: 0;height: 10px;position: absolute;left: 0px;top: 0px;border-radius: 5px;z-index: 1;}
.silder .bg::after{clear: both;content: "";width: 100%;height: 30px;position: absolute;left: 0px;top: -10px;z-index: 2;cursor: pointer;}
.silder_box{ max-width: 840px; margin: auto;}

/* 打开权益窗口 */
.maskRights{background: rgba(0, 0, 0, .6);width: 100%;height: 180%;height: 101%;position: fixed;top: 0px;left: 0px;padding: 10px;box-sizing: border-box;display: none;z-index: 9;text-align: center;}

.maskRightsTips,.maskLoginTips,.maskLoginMonitor,.buySuccess{display: none;}

.maskRightsTips,.maskLoginTips,.maskLoginMonitor,.buySuccess{border-radius: 10px;padding: 0px 10px 0px;box-sizing: border-box;background: #fff;height: 100%;position: relative;}
.maskRights .scroll_box{overflow-y: auto;height: 100%;box-sizing: border-box;}

.maskRights .close{
    width: 20px;height: 20px;background: url(../assets/close1.svg);position: absolute;top: 20px;right: 25px;cursor: pointer;z-index: 9;
}
.maskRights .close:hover{background: url(../assets/close-h.svg);}

.maskRights>div{display: none;border-radius: 10px;padding: 0px 10px 0px;box-sizing: border-box;background: #fff;max-width: 1200px;width: 100%;position: absolute;padding-top: 50px;padding-bottom: 50px;top: 20%;bottom: 20%;height: auto;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%);box-sizing: border-box;}
.maskRights>div>div{position: absolute;top: 46%;left: 50%;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);text-align: center;width: 100%;}

.maskRightsTips,.maskLoginTips,.maskLoginMonitor{padding-top: 50px;}
.maskLoginTips img,.buySuccess img{margin: auto;display: block;}
.maskLoginTips p,.maskLoginMonitor p,.buySuccess p{font-size: 18px;line-height: 28px;color: #333;max-width: 952px;width: 100%;text-align: center;margin: auto;}
.maskLoginTips p a{font-weight: bold;}
.maskLoginTips .btn,.maskRightsTips .btn,.buySuccess .btn{min-width: 240px;height: 50px;line-height: 50px;text-align: center;border-radius: 34px;background: #FF9602;display: inline-block;margin: 20px auto;font-size: 22px;color: #fff;cursor: pointer;padding-left: 70px;padding-right: 70px;box-sizing: border-box;}
.maskLoginTips .btn:hover,.maskRightsTips .btn:hover,.buySuccess .btn:hover{background: #FF8302;text-decoration: none;}

.maskLoginMonitor .img,.maskRightsTips .img{position: relative;margin: 0px  auto 14px;display: block;width: 100px;height: 100px;}
.maskLoginMonitor .img img:first-child,.maskRightsTips .img img:first-child{position: absolute;top: 50%;left: 50%;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
.maskLoginMonitor .img img:last-child,.maskRightsTips .img img:last-child{-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;position: absolute;top: 0px;left: 0px;}

.buySuccess p{display: none;}
.buySuccess p span{text-decoration: underline;color: #21a1f2;}
.buySuccess .register_btn{text-decoration: underline;cursor: pointer;}
/* 旋转 */
@-webkit-keyframes rotate {0% {-webkit-transform: rotate(0deg)}100% {-webkit-transform: rotate(360deg)}}
@-moz-keyframes rotate {0% {-moz-transform: rotate(0deg)}100% {-moz-transform: rotate(360deg)}}
@-o-keyframes rotate {0% {-o-transform: rotate(0deg)}100% {-o-transform: rotate(360deg)}}
.maskLoginMonitor .btn{min-width: 318px;padding-left: 30px;padding-right: 30px;box-sizing: border-box;border: 1px solid #FF8702;border-radius: 34px;line-height: 48px;font-size: 20px;color: #ff8702;display: inline-block;margin-top: 20px;}
.maskLoginMonitor .btn:hover{background: rgba(255, 104, 2, 0.09);text-decoration: none;}

.maskRightsTips .img img:last-child{display: none;}
.maskRightsTips .info{font-size: 16px;line-height: 20px;}
.maskRightsTips .box{margin-top: 10px;}
.maskRightsTips .box .btn{margin-left: 10px;margin-right: 10px;margin-top: 10px;}

/* 切入登录注册 */
.maskMember{position: fixed;z-index: 999;top: 0px;left: 0px;width: 100%;height: 100%;background: rgba(0, 0, 0, .2);display: none;}
.registerMaskbtn,.loginMaskbtn{cursor: pointer;}


.buy {
    background: #fff;
    padding-top: 48px;
    position: relative;
}

.buy::before {
    clear: both;
    content: "";
    width: 100%;
    height: 364px;
    background: linear-gradient(90deg, #D6F5FF 0%, #FFE3FE 49%, #FFECC8 100%);
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
}

.buy>div {
    position: relative;
    z-index: 2;
    overflow: visible;
}
.note_tips{
    max-width: 880px;
    width: 100%;
    margin: 30px auto 0;
    text-align: center;
    line-height: 30px;
}
.note_tips span{
    font-weight: bold;
}

.buy>div>h1 {
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #222;
    font-weight: bold;
}

.buy>div>p {
    font-size: 18px;
    color: #222;
    line-height: 24px;
    margin-top: 24px;
    text-align: center;
}

.buy_box {
    margin-top: 50px;
    align-items: flex-end;
    margin-bottom: 0px;
    justify-content: center;
}

.buy_box>div {
    box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.07);
    border-radius: 8px 8px 8px 8px;
    max-width: 380px;
    width: 100%;
    background: #fff;
    padding-top: 38px;
    padding-bottom: 38px;
    text-align: center;
    margin: 24px 7px;
    border: 2px solid #E7766E;
}

.buy_box .title {
    font-size: 24px;
    font-weight: bold;
    color: #222;
    line-height: 28px;
    text-align: center;
}
.buy_box .title i{
    background: url(../assets/best-seller.svg);
    width: 19px;
    height: 18px;
    display: inline-block;
    margin-right: 8px;
}
.buy_box.active{
    max-width: 800px;
}
.buy_box>div .credits {
    max-width: 305px;
    width: 99%;
    margin: auto;
    text-align: left;
    margin-top: 16px;
}

.buy_box>div .credits>div {
    border-bottom: 1px solid #979797;
    padding-bottom: 18px;
    margin-top: 18px;
    text-align: left;
    cursor: pointer;
}

.buy_box>div .credits>div * {
    vertical-align: middle;
}

.buy_box>div .credits span {
    font-size: 16px;
    color: #333;
    line-height: 20px;
    display: inline-block;
    width: 120px;
    position: relative;
}

.buy_box>div .credits span .off{
    min-width: 64px;
    width: auto;
    padding-left: 6px;
    padding-right: 6px;
    line-height: 18px;
    border-radius: 10px 10px 10px 0;
    background: #EB3E3E;
    position: absolute;
    top: -16px;
    left: 4px;
    font-size: 12px;
    color:#fff;
    font-weight: bold;
    box-sizing: border-box;
}
.buy_box>div .credits .price {
    font-weight: bold;
    width: 70px;
    margin: 0;
}

.buy_box>div .credits del {
    color: #666;
    line-height: 20px;
}

.buy_box>div .credits i {
    width: 14px;
    height: 14px;
    background: url(../assets/radio.svg);
    margin-right: 8px;
    cursor: pointer;
}

.buy_box>div .credits>div.active i {
    background-position-y: -14px;
}

.buy_box>div>.price {
    font-size: 46px;
    line-height: 54px;
    margin-top: 24px;
    text-align: center;
    font-weight: bold;
    color: #EB3E3E;
    display: block;
}

.buy_box .best {
    position: relative;
    margin-top: 0px;
    padding-top: 50px;
    max-width: 406px;
    border: 1px solid #4071FF;
}

.buy_box .lifetime {
    margin-top: 18px;
}


.buy_box .best>span:nth-child(1) {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    background: #EB3E3E;
    border-radius: 14px;
    line-height: 30px;
    padding: 0px 22px;
    position: absolute;
    left: 50%;
    top: 0px;
    transform: translate(-50%, -50%);
}

.buy_box .btn {
    cursor: pointer;
    min-width: 234px;
    line-height: 56px;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    display: inline-block;
    background: #EB3E3E;
    border-radius: 10px;
    margin-top: 40px;
    position: relative;
}

.buy_box .btn:hover span,
.buy_box .btn.load span{
    opacity: 0;
}
.buy_box .btn.load::before{
    clear: both;
    content: "";
    background: url(../assets/loading.svg);
    width: 16px;
    height: 16px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -8px;
    margin-left: -8px;
    animation: rotate 1.5s infinite linear;
}
.buy_box .btn.load::after{display: none;}
.buy_box .btn span {
    font-size: 20px;
    color: #fff;
    font-weight: bold;
}

.buy_box .btn::after {
    clear: both;
    content: "";
    width: 30px;
    height: 30px;
    position: absolute;
    left: 50%;
    top: -30px;
    transform: translate(-50%, -50%);
    background: url(../assets/cart.svg) no-repeat center center/cover;
}

.buy_box .btn:hover::after {
    top: 50%;
    transition: all .3s linear;
}

@media screen and (max-width:1220px){
    .maskRights>div{width: 95%;}
}
@media screen and (max-width:630px){
    .maskMember{background: #fff;}
    .member>.close{display: none;}
    .maskMember>.close{position: absolute;right: 14px;top: 14px;cursor: pointer;z-index: 2;width: 20px;height: 20px;background: url(/images/watermark-remover-online/close.svg);}
    .tab_nav ul li{width: 49%;box-sizing: border-box;min-width:auto;padding-left: 0px;padding-right: 0px;}
    .tab_nav ul{display: block;}
    .silder .num span{font-size: 14px;}
}
.flex-box {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: auto;
}
::-webkit-scrollbar {height: 8px;width: 0px;background: #fff;}

::-webkit-scrollbar-thumb{background: #f1f1f1;}
::-webkit-scrollbar-thumb:hover{background:#ddd}
::-webkit-scrollbar-thumb:active{background:#bbb}
</style>